<div class="conversation-thread" [class.conversation-thread--embedded]="embedded">
    <header *ngIf="showHeader" class="thread-header">
        <button *ngIf="showBack" type="button" mat-icon-button (click)="onBack()" [attr.aria-label]="'Voltar' | autoTranslate">
            <mat-icon svgIcon="heroicons_outline:arrow-left"></mat-icon>
        </button>
        <div class="thread-title">
            <h3 *ngIf="conversation?.type === 'GROUP' || conversation?.type === 'SERVICE'" autoTranslate>Grupo</h3>
            <h3 *ngIf="conversation?.type !== 'GROUP' && conversation?.type !== 'SERVICE'">
                {{ conversation?.display_name || conversation?.name || ('Conversa' | autoTranslate) }}
            </h3>
            <p *ngIf="conversation?.type === 'SERVICE'">
                #{{ conversation?.service_id }}
                ·
                {{ (conversation?.service_start || conversation?.createdAt) | timezoneDate: 'dd/MM/yyyy HH:mm' }}
            </p>
            <p *ngIf="conversation?.type === 'GROUP'">{{ conversation?.display_name || conversation?.name }}</p>
        </div>
        <button
            *ngIf="showVideoButton"
            type="button"
            mat-icon-button
            [matTooltip]="'Entrar em vídeo' | autoTranslate"
            (click)="onEnterVideo()"
        >
            <mat-icon svgIcon="heroicons_outline:video-camera"></mat-icon>
        </button>
    </header>

    <div #scrollContainer class="thread-messages">
        <div
            *ngFor="let msg of messages; let i = index; let first = first"
            class="msg-row"
            [class.msg-row--mine]="isMine(msg)"
            [class.msg-row--system]="msg.type === 'SYSTEM'"
        >
            <ng-container *ngIf="msg.type !== 'SYSTEM' && (first || shouldShowDay(messages[i - 1], msg))">
                <div class="msg-day">
                    <span>{{ msg.createdAt | timezoneDate : 'dd/MM/yyyy' }}</span>
                </div>
            </ng-container>

            <div *ngIf="msg.type === 'SYSTEM'" class="msg-system">
                <span class="msg-system-text">{{ msg.content }}</span>
                <span class="msg-system-time">{{ msg.createdAt | timezoneDate: 'dd/MM/yyyy HH:mm' }}</span>
            </div>

            <div
                *ngIf="msg.type !== 'SYSTEM'"
                class="msg-content"
                [class.msg-content--mine]="isMine(msg)"
            >
                <button
                    *ngIf="msg.failed && msg.temp_id && isMine(msg)"
                    type="button"
                    class="msg-resend"
                    (click)="resendMessage(msg)"
                    [matTooltip]="'Toque para reenviar' | autoTranslate"
                    [attr.aria-label]="'Toque para reenviar' | autoTranslate"
                >
                    <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                </button>

                <div
                    class="msg-bubble"
                    [class.msg-bubble--mine]="isMine(msg)"
                    [class.msg-bubble--pending]="msg.optimistic"
                >
                    <p class="msg-author">{{ msg.user?.name || ('Sistema' | autoTranslate) }}</p>
                    <p *ngIf="msg.type === 'TEXT'" class="msg-text">{{ msg.content }}</p>

                    <div *ngIf="msg.type === 'AUDIO' && msg.file_url" class="msg-audio">
                        <audio-player
                            [id]="msg.conversation_message_id"
                            [next]="messages[i + 1]?.type === 'AUDIO' ? messages[i + 1]?.conversation_message_id : null"
                            [src]="msg.file_url"
                            [fromMe]="isMine(msg)"
                        ></audio-player>
                    </div>

                    <button
                        *ngIf="msg.type === 'IMAGE' && msg.file_url"
                        type="button"
                        class="msg-image-btn"
                        (click)="openImageLightbox(msg, $event)"
                        [attr.aria-label]="(msg.file_name || 'Imagem') | autoTranslate"
                    >
                        <img [src]="msg.file_url" [alt]="msg.file_name || ('Imagem' | autoTranslate)" class="msg-image" />
                    </button>

                    <div *ngIf="msg.type === 'FILE' && !msg.file_url && msg.optimistic" class="msg-file msg-file--pending">
                        <mat-icon svgIcon="heroicons_outline:paper-clip"></mat-icon>
                        <span>{{ msg.file_name || msg.content || ('Enviando arquivo...' | autoTranslate) }}</span>
                    </div>

                    <ng-container *ngIf="msg.type === 'FILE' && msg.file_url">
                        <button
                            *ngIf="isImageAttachment(msg); else fileLink"
                            type="button"
                            class="msg-file"
                            (click)="openImageLightbox(msg, $event)"
                        >
                            <mat-icon svgIcon="heroicons_outline:photo"></mat-icon>
                            <span>{{ msg.file_name || msg.content || ('Imagem' | autoTranslate) }}</span>
                        </button>
                        <ng-template #fileLink>
                            <a
                                [href]="msg.file_url"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="msg-file"
                            >
                                <mat-icon svgIcon="heroicons_outline:paper-clip"></mat-icon>
                                <span>{{ msg.file_name || msg.content || ('Arquivo' | autoTranslate) }}</span>
                            </a>
                        </ng-template>
                    </ng-container>

                    <span class="msg-time">
                        {{ msg.createdAt | timezoneDate : 'HH:mm' }}
                        <span *ngIf="msg.optimistic" class="msg-pending-dot" aria-hidden="true">…</span>
                    </span>
                </div>
            </div>
        </div>
        <p *ngIf="messages.length === 0" class="empty-hint" autoTranslate>Nenhuma mensagem ainda. Diga olá!</p>
    </div>

    <div class="thread-composer" *ngIf="conversation?.status !== 'ARCHIVED'">
        <div *ngIf="isRecording" class="recording-bar">
            <span class="recording-time">{{ formatDuration(recordingDuration) }}</span>
            <button type="button" mat-icon-button color="warn" (click)="cancelRecording()">
                <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
            <button type="button" mat-icon-button color="primary" (click)="sendAudio()">
                <mat-icon svgIcon="heroicons_outline:paper-airplane"></mat-icon>
            </button>
        </div>

        <div *ngIf="!isRecording" class="composer-row">
            <input #fileInput type="file" class="hidden" (change)="onFileSelected($event)" />
            <input
                #cameraInput
                type="file"
                class="hidden"
                accept="image/*"
                capture="environment"
                (change)="onFileSelected($event)"
            />
            <button
                type="button"
                mat-icon-button
                class="composer-action"
                [matMenuTriggerFor]="attachMenu"
                [matTooltip]="'Anexar ou tirar foto' | autoTranslate"
            >
                <mat-icon svgIcon="heroicons_outline:paper-clip"></mat-icon>
            </button>
            <mat-menu #attachMenu="matMenu" class="conversation-attach-menu">
                <button type="button" mat-menu-item (click)="triggerFileInput($event)">
                    <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                    <span autoTranslate>Anexar arquivo</span>
                </button>
                <button type="button" mat-menu-item (click)="triggerCameraInput($event)">
                    <mat-icon svgIcon="heroicons_outline:camera"></mat-icon>
                    <span autoTranslate>Tirar foto</span>
                </button>
            </mat-menu>
            <div class="composer-field">
                <textarea
                    #composerInput
                    class="composer-input"
                    rows="1"
                    [(ngModel)]="newMessageText"
                    (input)="resizeComposer()"
                    (keydown)="onComposerKeydown($event)"
                    [placeholder]="'Digite uma mensagem...' | autoTranslate"
                ></textarea>
            </div>
            <button
                *ngIf="!newMessageText?.trim()"
                type="button"
                mat-icon-button
                class="composer-action"
                (click)="startRecording()"
                [matTooltip]="'Áudio' | autoTranslate"
            >
                <mat-icon svgIcon="heroicons_outline:microphone"></mat-icon>
            </button>
            <button
                *ngIf="newMessageText?.trim()"
                type="button"
                mat-icon-button
                class="composer-action composer-action--send"
                color="primary"
                (click)="sendMessage()"
            >
                <mat-icon svgIcon="heroicons_outline:paper-airplane"></mat-icon>
            </button>
        </div>
    </div>
    <div *ngIf="conversation?.status === 'ARCHIVED'" class="archived-hint" autoTranslate>
        Conversa arquivada — apenas leitura
    </div>
</div>
